import { emptySplitApi as api } from "./emptyApi";
const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        batchAanmelden: build.mutation<BatchAanmeldenApiResponse, BatchAanmeldenApiArg>({
            query: (queryArg) => ({ url: `/api/aanmelding`, method: "PUT", body: queryArg.batchAanmelding }),
        }),
        lastYearUsers: build.query<LastYearUsersApiResponse, LastYearUsersApiArg>({
            query: () => ({ url: `/api/aanmelding/last-year-users` }),
        }),
        monthlyReportGroupedByWeek: build.query<MonthlyReportGroupedByWeekApiResponse, MonthlyReportGroupedByWeekApiArg>({
            query: (queryArg) => ({ url: `/api/aanmelding/month-report-grouped-by-week/${queryArg.datum}/${queryArg.userId}` }),
        }),
        monthlyReport: build.query<MonthlyReportApiResponse, MonthlyReportApiArg>({
            query: (queryArg) => ({ url: `/api/aanmelding/month-report/${queryArg.datum}/${queryArg.userId}` }),
        }),
        getUpcomingAanmeldingenForUser: build.query<GetUpcomingAanmeldingenForUserApiResponse, GetUpcomingAanmeldingenForUserApiArg>({
            query: (queryArg) => ({
                url: `/api/aanmelding/upcoming/${queryArg.userId}`,
                params: {
                    fromDate: queryArg.fromDate,
                    maxAmount: queryArg.maxAmount,
                    toDate: queryArg.toDate,
                },
            }),
        }),
        getAanmeldingenOnDate: build.query<GetAanmeldingenOnDateApiResponse, GetAanmeldingenOnDateApiArg>({
            query: (queryArg) => ({ url: `/api/aanmelding/${queryArg.datum}` }),
        }),
        afmelden: build.mutation<AfmeldenApiResponse, AfmeldenApiArg>({
            query: (queryArg) => ({ url: `/api/aanmelding/${queryArg.datum}/${queryArg.userId}`, method: "DELETE" }),
        }),
        getAanmeldingenOnDateForUser: build.query<GetAanmeldingenOnDateForUserApiResponse, GetAanmeldingenOnDateForUserApiArg>({
            query: (queryArg) => ({ url: `/api/aanmelding/${queryArg.datum}/${queryArg.userId}` }),
        }),
        aanmelden: build.mutation<AanmeldenApiResponse, AanmeldenApiArg>({
            query: (queryArg) => ({ url: `/api/aanmelding/${queryArg.datum}/${queryArg.userId}`, method: "PUT", body: queryArg.aanmeldingOptions }),
        }),
        getBedrijven: build.query<GetBedrijvenApiResponse, GetBedrijvenApiArg>({
            query: () => ({ url: `/api/bedrijf` }),
        }),
        getBedrijfForUser: build.query<GetBedrijfForUserApiResponse, GetBedrijfForUserApiArg>({
            query: (queryArg) => ({ url: `/api/bedrijf/for-user/${queryArg.user}` }),
        }),
        updateCompany: build.mutation<UpdateCompanyApiResponse, UpdateCompanyApiArg>({
            query: (queryArg) => ({ url: `/api/bedrijf/${queryArg.name}`, method: "PUT", body: queryArg.companyWrite }),
        }),
        deleteCompany: build.mutation<DeleteCompanyApiResponse, DeleteCompanyApiArg>({
            query: (queryArg) => ({ url: `/api/bedrijf/${queryArg.name}`, method: "DELETE" }),
        }),
        createCompany: build.mutation<CreateCompanyApiResponse, CreateCompanyApiArg>({
            query: (queryArg) => ({ url: `/api/bedrijf/${queryArg.name}`, method: "POST", body: queryArg.companyWrite }),
        }),
        getBedrijfByName: build.query<GetBedrijfByNameApiResponse, GetBedrijfByNameApiArg>({
            query: (queryArg) => ({ url: `/api/bedrijf/${queryArg.name}` }),
        }),
        getCompanyDeleteImpact: build.query<GetCompanyDeleteImpactApiResponse, GetCompanyDeleteImpactApiArg>({
            query: (queryArg) => ({ url: `/api/bedrijf/${queryArg.name}/delete-impact` }),
        }),
        getApiDeploymentInfo: build.query<GetApiDeploymentInfoApiResponse, GetApiDeploymentInfoApiArg>({
            query: () => ({ url: `/api/deployment-info` }),
        }),
        getRedeliveryProbe: build.query<GetRedeliveryProbeApiResponse, GetRedeliveryProbeApiArg>({
            query: (queryArg) => ({ url: `/api/diagnostics/redelivery-probe/${queryArg.id}` }),
        }),
        createRedeliveryProbe: build.mutation<CreateRedeliveryProbeApiResponse, CreateRedeliveryProbeApiArg>({
            query: (queryArg) => ({ url: `/api/diagnostics/redelivery-probe/${queryArg.id}`, method: "PUT" }),
        }),
        getAllBuildings: build.query<GetAllBuildingsApiResponse, GetAllBuildingsApiArg>({
            query: () => ({ url: `/api/gebouw` }),
        }),
        regenerateDefaults: build.mutation<RegenerateDefaultsApiResponse, RegenerateDefaultsApiArg>({
            query: () => ({ url: `/api/gebouw/defaults`, method: "POST" }),
        }),
        migrateSyntheticRooms: build.mutation<MigrateSyntheticRoomsApiResponse, MigrateSyntheticRoomsApiArg>({
            query: () => ({ url: `/api/gebouw/migrate-synthetic-rooms`, method: "POST" }),
        }),
        getBuildingPictures: build.query<GetBuildingPicturesApiResponse, GetBuildingPicturesApiArg>({
            query: () => ({ url: `/api/gebouw/pictures` }),
        }),
        updateBuilding: build.mutation<UpdateBuildingApiResponse, UpdateBuildingApiArg>({
            query: (queryArg) => ({ url: `/api/gebouw/${queryArg.building}`, method: "PUT", body: queryArg.buildingUpdate }),
        }),
        deleteBuilding: build.mutation<DeleteBuildingApiResponse, DeleteBuildingApiArg>({
            query: (queryArg) => ({ url: `/api/gebouw/${queryArg.building}`, method: "DELETE" }),
        }),
        createBuilding: build.mutation<CreateBuildingApiResponse, CreateBuildingApiArg>({
            query: (queryArg) => ({ url: `/api/gebouw/${queryArg.building}`, method: "POST" }),
        }),
        getBuilding: build.query<GetBuildingApiResponse, GetBuildingApiArg>({
            query: (queryArg) => ({ url: `/api/gebouw/${queryArg.building}` }),
        }),
        setDefaultBuilding: build.mutation<SetDefaultBuildingApiResponse, SetDefaultBuildingApiArg>({
            query: (queryArg) => ({ url: `/api/gebouw/${queryArg.building}/default`, method: "POST" }),
        }),
        upsertRoom: build.mutation<UpsertRoomApiResponse, UpsertRoomApiArg>({
            query: (queryArg) => ({ url: `/api/gebouw/${queryArg.building}/rooms/${queryArg.room}`, method: "PUT", body: queryArg.roomSize }),
        }),
        renameRoom: build.mutation<RenameRoomApiResponse, RenameRoomApiArg>({
            query: (queryArg) => ({ url: `/api/gebouw/${queryArg.building}/rooms/${queryArg.room}`, method: "POST", body: queryArg.roomNameUpdate }),
        }),
        deleteRoom: build.mutation<DeleteRoomApiResponse, DeleteRoomApiArg>({
            query: (queryArg) => ({ url: `/api/gebouw/${queryArg.building}/rooms/${queryArg.room}`, method: "DELETE" }),
        }),
        unblockRoom: build.mutation<UnblockRoomApiResponse, UnblockRoomApiArg>({
            query: (queryArg) => ({ url: `/api/gebouw/${queryArg.building}/${queryArg.room}/${queryArg.date}`, method: "PUT" }),
        }),
        blockRoom: build.mutation<BlockRoomApiResponse, BlockRoomApiArg>({
            query: (queryArg) => ({ url: `/api/gebouw/${queryArg.building}/${queryArg.room}/${queryArg.date}`, method: "DELETE" }),
        }),
        getAllKantoordagen: build.query<GetAllKantoordagenApiResponse, GetAllKantoordagenApiArg>({
            query: () => ({ url: `/api/kantoordag` }),
        }),
        getKantoordagOnDate: build.query<GetKantoordagOnDateApiResponse, GetKantoordagOnDateApiArg>({
            query: (queryArg) => ({ url: `/api/kantoordag/${queryArg.datum}/${queryArg.building}` }),
        }),
        getMessagesOfTheDay: build.query<GetMessagesOfTheDayApiResponse, GetMessagesOfTheDayApiArg>({
            query: (queryArg) => ({
                url: `/api/motd`,
                params: {
                    since: queryArg.since,
                },
            }),
        }),
        sendIllegalParkingReport: build.mutation<SendIllegalParkingReportApiResponse, SendIllegalParkingReportApiArg>({
            query: (queryArg) => ({ url: `/api/parking/report/illegal/${queryArg.datum}`, method: "POST" }),
        }),
        getIllegalParkingReport: build.query<GetIllegalParkingReportApiResponse, GetIllegalParkingReportApiArg>({
            query: (queryArg) => ({ url: `/api/parking/report/illegal/${queryArg.datum}` }),
        }),
        getParkingSpots: build.query<GetParkingSpotsApiResponse, GetParkingSpotsApiArg>({
            query: (queryArg) => ({ url: `/api/parking/${queryArg.building}/${queryArg.datum}` }),
        }),
        assignParkingSpots: build.mutation<AssignParkingSpotsApiResponse, AssignParkingSpotsApiArg>({
            query: (queryArg) => ({ url: `/api/parking/${queryArg.building}/${queryArg.datum}`, method: "PUT", body: queryArg.body }),
        }),
        getIllegalParkingReportForBuilding: build.query<GetIllegalParkingReportForBuildingApiResponse, GetIllegalParkingReportForBuildingApiArg>({
            query: (queryArg) => ({ url: `/api/parking/${queryArg.building}/${queryArg.datum}/illegal` }),
        }),
        exchangeFirebaseToken: build.mutation<ExchangeFirebaseTokenApiResponse, ExchangeFirebaseTokenApiArg>({
            query: () => ({ url: `/api/session/firebase-token`, method: "POST" }),
        }),
        storeApnToken: build.mutation<StoreApnTokenApiResponse, StoreApnTokenApiArg>({
            query: (queryArg) => ({ url: `/api/user/apn/${queryArg.userId}`, method: "PUT", body: queryArg.apnToken }),
        }),
        listExternalUsers: build.query<ListExternalUsersApiResponse, ListExternalUsersApiArg>({
            query: () => ({ url: `/api/user/external` }),
        }),
        createExternalUser: build.mutation<CreateExternalUserApiResponse, CreateExternalUserApiArg>({
            query: (queryArg) => ({ url: `/api/user/external`, method: "POST", body: queryArg.externalUser }),
        }),
        revokeExternalUser: build.mutation<RevokeExternalUserApiResponse, RevokeExternalUserApiArg>({
            query: (queryArg) => ({ url: `/api/user/external/${queryArg.id}`, method: "DELETE" }),
        }),
        reinstateExternalUser: build.mutation<ReinstateExternalUserApiResponse, ReinstateExternalUserApiArg>({
            query: (queryArg) => ({ url: `/api/user/external/${queryArg.id}/reinstate`, method: "POST" }),
        }),
        resendExternalUserInvitation: build.mutation<ResendExternalUserInvitationApiResponse, ResendExternalUserInvitationApiArg>({
            query: (queryArg) => ({ url: `/api/user/external/${queryArg.id}/resend`, method: "POST" }),
        }),
        getUserPreferences: build.query<GetUserPreferencesApiResponse, GetUserPreferencesApiArg>({
            query: () => ({ url: `/api/user/me/preferences` }),
        }),
        storeNotificationPreference: build.mutation<StoreNotificationPreferenceApiResponse, StoreNotificationPreferenceApiArg>({
            query: (queryArg) => ({
                url: `/api/user/me/preferences/notifications/${queryArg.notification}`,
                method: "PUT",
                body: queryArg.notificationPreferred,
            }),
        }),
        storeSignupPreference: build.mutation<StoreSignupPreferenceApiResponse, StoreSignupPreferenceApiArg>({
            query: (queryArg) => ({ url: `/api/user/me/preferences/signup`, method: "PUT", body: queryArg.signupPrefs }),
        }),
        clearPhotoCache: build.mutation<ClearPhotoCacheApiResponse, ClearPhotoCacheApiArg>({
            query: () => ({ url: `/api/user/photo/cache/clear`, method: "POST" }),
        }),
        getUserProfileImage: build.query<GetUserProfileImageApiResponse, GetUserProfileImageApiArg>({
            query: (queryArg) => ({ url: `/api/user/${queryArg.userId}/photo` }),
        }),
        generateKantoordagView: build.mutation<GenerateKantoordagViewApiResponse, GenerateKantoordagViewApiArg>({
            query: (queryArg) => ({ url: `/api/views/kantoordag/${queryArg.building}/${queryArg.datum}`, method: "POST" }),
        }),
        migrateViews: build.mutation<MigrateViewsApiResponse, MigrateViewsApiArg>({
            query: (queryArg) => ({ url: `/api/views/migrate/${queryArg.migrator}`, method: "POST", body: queryArg.migratorParams }),
        }),
        regenerateMyReservationsViews: build.mutation<RegenerateMyReservationsViewsApiResponse, RegenerateMyReservationsViewsApiArg>({
            query: (queryArg) => ({
                url: `/api/views/my-reservations/regenerate`,
                method: "POST",
                params: {
                    fromDate: queryArg.fromDate,
                    includeHistory: queryArg.includeHistory,
                },
            }),
        }),
        getWorkplaceOnDateForBuilding: build.query<GetWorkplaceOnDateForBuildingApiResponse, GetWorkplaceOnDateForBuildingApiArg>({
            query: (queryArg) => ({ url: `/api/workplace/${queryArg.building}/${queryArg.datum}` }),
        }),
        getWorkplaceOnDate: build.query<GetWorkplaceOnDateApiResponse, GetWorkplaceOnDateApiArg>({
            query: (queryArg) => ({ url: `/api/workplace/${queryArg.datum}` }),
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as kantoordagApi };
export type BatchAanmeldenApiResponse =
    /** status 200 Lijst van alle datums waarvoor er al een aanmelding bestaat - deze blijven onveranderd */ BatchAanmeldenResponse;
export type BatchAanmeldenApiArg = {
    batchAanmelding: BatchAanmelding;
};
export type LastYearUsersApiResponse = /** status 200 OK */ Usernames;
export type LastYearUsersApiArg = void;
export type MonthlyReportGroupedByWeekApiResponse = /** status 200 OK */ MonthReportGroupedByWeek;
export type MonthlyReportGroupedByWeekApiArg = {
    /** Datum in formaat YYYY-MM-DD */
    datum: string;
    /** Gebruikers-id */
    userId: string;
};
export type MonthlyReportApiResponse = /** status 200 OK */ MonthReport;
export type MonthlyReportApiArg = {
    /** Datum in formaat YYYY-MM-DD */
    datum: string;
    /** Gebruikers-id */
    userId: string;
};
export type GetUpcomingAanmeldingenForUserApiResponse = /** status 200 OK */ AanmeldingView[];
export type GetUpcomingAanmeldingenForUserApiArg = {
    userId: string;
    fromDate?: string | null;
    maxAmount: number;
    toDate?: string | null;
};
export type GetAanmeldingenOnDateApiResponse = /** status 200 OK */ AanmeldingView[];
export type GetAanmeldingenOnDateApiArg = {
    /** Datum in formaat YYYY-MM-DD. Dit is de datum waarvoor we de aanmeldingen ophalen */
    datum: string;
};
export type AfmeldenApiResponse = unknown;
export type AfmeldenApiArg = {
    datum: string;
    userId: string;
};
export type GetAanmeldingenOnDateForUserApiResponse = /** status 200 OK */ AanmeldingView;
export type GetAanmeldingenOnDateForUserApiArg = {
    /** Datum in formaat YYYY-MM-DD */
    datum: string;
    /** Gebruikers-id */
    userId: string;
};
export type AanmeldenApiResponse = unknown;
export type AanmeldenApiArg = {
    datum: string;
    userId: string;
    aanmeldingOptions: AanmeldingOptions;
};
export type GetBedrijvenApiResponse = /** status 200 OK */ string[];
export type GetBedrijvenApiArg = void;
export type GetBedrijfForUserApiResponse = /** status 200 Succes */ BedrijfView;
export type GetBedrijfForUserApiArg = {
    /** Gebruikers-id */
    user: string;
};
export type UpdateCompanyApiResponse = unknown;
export type UpdateCompanyApiArg = {
    /** Naam van het bedrijf */
    name: string;
    companyWrite: CompanyWrite;
};
export type DeleteCompanyApiResponse = unknown;
export type DeleteCompanyApiArg = {
    /** Naam van het bedrijf */
    name: string;
};
export type CreateCompanyApiResponse = unknown;
export type CreateCompanyApiArg = {
    /** Naam van het bedrijf */
    name: string;
    companyWrite: CompanyWrite;
};
export type GetBedrijfByNameApiResponse = /** status 200 OK */ BedrijfView;
export type GetBedrijfByNameApiArg = {
    /** Naam van het bedrijf */
    name: string;
};
export type GetCompanyDeleteImpactApiResponse = /** status 200 OK */ DeleteImpact;
export type GetCompanyDeleteImpactApiArg = {
    /** Naam van het bedrijf */
    name: string;
};
export type GetApiDeploymentInfoApiResponse = /** status 200 OK */ DeploymentInfoResponse;
export type GetApiDeploymentInfoApiArg = void;
export type GetRedeliveryProbeApiResponse = unknown;
export type GetRedeliveryProbeApiArg = {
    id: string;
};
export type CreateRedeliveryProbeApiResponse = unknown;
export type CreateRedeliveryProbeApiArg = {
    id: string;
};
export type GetAllBuildingsApiResponse = /** status 200 OK */ BuildingView[];
export type GetAllBuildingsApiArg = void;
export type RegenerateDefaultsApiResponse = unknown;
export type RegenerateDefaultsApiArg = void;
export type MigrateSyntheticRoomsApiResponse = unknown;
export type MigrateSyntheticRoomsApiArg = void;
export type GetBuildingPicturesApiResponse = /** status 200 OK */ string[];
export type GetBuildingPicturesApiArg = void;
export type UpdateBuildingApiResponse = unknown;
export type UpdateBuildingApiArg = {
    /** Naam van het gebouw */
    building: string;
    buildingUpdate: BuildingUpdate;
};
export type DeleteBuildingApiResponse = unknown;
export type DeleteBuildingApiArg = {
    /** Naam van het gebouw */
    building: string;
};
export type CreateBuildingApiResponse = unknown;
export type CreateBuildingApiArg = {
    /** Naam van het gebouw */
    building: string;
};
export type GetBuildingApiResponse = /** status 200 OK */ BuildingView;
export type GetBuildingApiArg = {
    /** Naam van het gebouw */
    building: string;
};
export type SetDefaultBuildingApiResponse = unknown;
export type SetDefaultBuildingApiArg = {
    /** Naam van het gebouw */
    building: string;
};
export type UpsertRoomApiResponse = unknown;
export type UpsertRoomApiArg = {
    /** Naam van het gebouw */
    building: string;
    /** Naam van de kamer */
    room: string;
    roomSize: RoomSize;
};
export type RenameRoomApiResponse = unknown;
export type RenameRoomApiArg = {
    /** Naam van het gebouw */
    building: string;
    /** Huidige naam van de kamer */
    room: string;
    roomNameUpdate: RoomNameUpdate;
};
export type DeleteRoomApiResponse = unknown;
export type DeleteRoomApiArg = {
    /** Naam van het gebouw */
    building: string;
    /** Naam van de kamer */
    room: string;
};
export type UnblockRoomApiResponse = unknown;
export type UnblockRoomApiArg = {
    /** Naam van het gebouw */
    building: string;
    /** Datum in formaat YYYY-MM-DD */
    date: string;
    /** Naam van de kamer */
    room: string;
};
export type BlockRoomApiResponse = unknown;
export type BlockRoomApiArg = {
    /** Naam van het gebouw */
    building: string;
    /** Datum in formaat YYYY-MM-DD */
    date: string;
    /** Naam van de kamer */
    room: string;
};
export type GetAllKantoordagenApiResponse = /** status 200 OK */ string[];
export type GetAllKantoordagenApiArg = void;
export type GetKantoordagOnDateApiResponse = /** status 200 OK */ KantoordagViewResponse;
export type GetKantoordagOnDateApiArg = {
    /** Naam van het gebouw. Gebruik een waarde uit GET /api/gebouw (veld name). */
    building: string;
    /** Datum in formaat YYYY-MM-DD (ISO-8601). */
    datum: string;
};
export type GetMessagesOfTheDayApiResponse = /** status 200 OK */ MessageOfTheDay[];
export type GetMessagesOfTheDayApiArg = {
    /** Alleen berichten met id groter dan deze waarde */
    since?: number | null;
};
export type SendIllegalParkingReportApiResponse = unknown;
export type SendIllegalParkingReportApiArg = {
    /** Datum in formaat YYYY-MM-DD (ISO-8601). */
    datum: string;
};
export type GetIllegalParkingReportApiResponse = /** status 200 OK */ IllegalParkingReport;
export type GetIllegalParkingReportApiArg = {
    /** Datum in formaat YYYY-MM-DD (ISO-8601). */
    datum: string;
};
export type GetParkingSpotsApiResponse = /** status 200 OK */ ReservationView[];
export type GetParkingSpotsApiArg = {
    /** Naam van het gebouw. Gebruik een waarde uit GET /api/gebouw (veld name). */
    building: string;
    /** Datum in formaat YYYY-MM-DD (ISO-8601). */
    datum: string;
};
export type AssignParkingSpotsApiResponse = unknown;
export type AssignParkingSpotsApiArg = {
    /** Naam van het gebouw. Gebruik een waarde uit GET /api/gebouw (veld name). */
    building: string;
    /** Datum in formaat YYYY-MM-DD (ISO-8601). */
    datum: string;
    body: string[];
};
export type GetIllegalParkingReportForBuildingApiResponse = /** status 200 OK */ IllegalParkingReport;
export type GetIllegalParkingReportForBuildingApiArg = {
    /** Naam van het gebouw. Gebruik een waarde uit GET /api/gebouw (veld name). */
    building: string;
    /** Datum in formaat YYYY-MM-DD (ISO-8601). */
    datum: string;
};
export type ExchangeFirebaseTokenApiResponse = /** status 200 Firebase custom token aangemaakt */ FirebaseTokenResponse;
export type ExchangeFirebaseTokenApiArg = void;
export type StoreApnTokenApiResponse = unknown;
export type StoreApnTokenApiArg = {
    /** Gebruikers-id */
    userId: string;
    apnToken: ApnToken;
};
export type ListExternalUsersApiResponse = /** status 200 Lijst van externe gebruikers */ ExternalUserSummary[];
export type ListExternalUsersApiArg = void;
export type CreateExternalUserApiResponse = unknown;
export type CreateExternalUserApiArg = {
    externalUser: ExternalUser;
};
export type RevokeExternalUserApiResponse = unknown;
export type RevokeExternalUserApiArg = {
    /** Entra object GUID van de externe gebruiker */
    id: string;
};
export type ReinstateExternalUserApiResponse = unknown;
export type ReinstateExternalUserApiArg = {
    /** Entra object GUID van de externe gebruiker */
    id: string;
};
export type ResendExternalUserInvitationApiResponse = unknown;
export type ResendExternalUserInvitationApiArg = {
    /** Entra object GUID van de externe gebruiker */
    id: string;
};
export type GetUserPreferencesApiResponse = /** status 200 OK */ UserPreferences;
export type GetUserPreferencesApiArg = void;
export type StoreNotificationPreferenceApiResponse = unknown;
export type StoreNotificationPreferenceApiArg = {
    /** Type notificatie */
    notification: Notification;
    notificationPreferred: NotificationPreferred;
};
export type StoreSignupPreferenceApiResponse = unknown;
export type StoreSignupPreferenceApiArg = {
    signupPrefs: SignupPrefs;
};
export type ClearPhotoCacheApiResponse = unknown;
export type ClearPhotoCacheApiArg = void;
export type GetUserProfileImageApiResponse = /** status 200 Profielfoto opgehaald */ any;
export type GetUserProfileImageApiArg = {
    /** Gebruikers-id */
    userId: string;
};
export type GenerateKantoordagViewApiResponse = unknown;
export type GenerateKantoordagViewApiArg = {
    /** Naam van het gebouw. Gebruik een waarde uit GET /api/gebouw (veld name). */
    building: string;
    /** Datum in formaat YYYY-MM-DD (ISO-8601). */
    datum: string;
};
export type MigrateViewsApiResponse =
    /** status 200 Gestreamde JSON-array met MigratedItem per verwerkte batch, terwijl de migratie nog loopt */ MigratedItem[];
export type MigrateViewsApiArg = {
    migrator: Migrators;
    migratorParams: MigratorParams;
};
export type RegenerateMyReservationsViewsApiResponse =
    /** status 200 Gestreamde JSON-array met MigratedItem per verwerkte batch, terwijl de migratie nog loopt */ MigratedItem[];
export type RegenerateMyReservationsViewsApiArg = {
    /** Datum in formaat YYYY-MM-DD (ISO-8601). Regenereer alleen vanaf deze datum; heeft voorrang op `includeHistory`. */
    fromDate?: string | null;
    /** Regenereer ook de volledige geschiedenis, niet alleen aankomende aanmeldingen */
    includeHistory: boolean;
};
export type GetWorkplaceOnDateForBuildingApiResponse = /** status 200 OK */ WorkplaceView;
export type GetWorkplaceOnDateForBuildingApiArg = {
    /** Naam van het gebouw. Gebruik een waarde uit GET /api/gebouw (veld name). */
    building: string;
    /** Datum in formaat YYYY-MM-DD (ISO-8601). */
    datum: string;
};
export type GetWorkplaceOnDateApiResponse = /** status 200 OK */ WorkplaceView;
export type GetWorkplaceOnDateApiArg = {
    /** Datum in formaat YYYY-MM-DD (ISO-8601). */
    datum: string;
};
export type BatchAanmeldenResponse = {
    /** Datums waarvoor al een aanmelding bestond - deze blijven onveranderd */
    existingDates: string[];
};
export type AanmeldingOptions = {
    /** Het gebouw waar de aanmelding voor geldt. De informatie van het gebouw is via het building endpoint op te halen */
    building?: string | null;
    /** De kamerwaarde voor de aanmelding. Geldige waarden zijn gebouwspecifiek en moeten passen bij het gekozen gebouw. NoRoom betekent dat geen specifieke werkplek nodig is (bijvoorbeeld een vaste plek of een gebouw zonder kamerselectie). AutomaticAssignment betekent dat het systeem de eerste beschikbare werkplek kiest, of anders de gebruiker op de wachtlijst plaatst. */
    room?: string | null;
    /** Is een parkeerplek gevraagd */
    parkingRequested?: boolean | null;
    /** Voor welke periode wil je je aanmelden */
    periode?: Periode | null;
};
export type BatchAanmelding = {
    /** Gebruikers-id waarvoor de batchaanmelding wordt uitgevoerd */
    userId: string;
    /** Lijst van datums (YYYY-MM-DD) waarvoor wordt aangemeld */
    data: string[];
    /** Opties die op alle datums in de batch worden toegepast */
    options: AanmeldingOptions;
};
export type Usernames = {
    /** Lijst met gebruikers-id's */
    users: string[];
};
export type LocalDate = string;
export type DayReport = {
    date: LocalDate;
    inOffice: boolean;
};
export type WeekReport = {
    weekNumber: number;
    days: DayReport[];
    daysAtHome: number;
    daysInOffice: number;
};
export type MonthReportGroupedByWeek = {
    weeks: WeekReport[];
    totalDaysAtHome: number;
    totalDaysInOffice: number;
};
export type MonthReport = {
    days: DayReport[];
};
export type AanmeldingView = {
    /** De datum van de aanmelding */
    datum: LocalDate;
    /** De id van de gebruiker. */
    userId: string;
    /** De naam van de gebruiker. */
    name: string;
    /** De URL van de profielfoto van de gebruiker. Kan null zijn als er geen profielfoto is. */
    picture?: string | null;
    /** Heeft de gebruiker een werkplek aangevraagd */
    werkplek: boolean;
    /** Het bedrijf waar de gebruiker toe behoort. De informatie van het bedrijf is via het bedrijf endpoint op te halen */
    company: string;
    /** Het gebouw waar de aanmelding voor geldt. De informatie van het gebouw is via het building endpoint op te halen */
    building: string;
    /** De kamer waar de aanmelding voor geldt. Deze kamer valt binnen het gebouw waar de aanmelding voor geldt. Als de kamer de waarde NO_ROOM heeft, is er geen kamer aangevraagd */
    room: string;
    /** Heeft de gebruiker een parkeerplek aangevraagd */
    parkingRequested: boolean;
    /** Is er een parkeerplek toegewezen aan de gebruiker. Deze waarde kan alleen true zijn als parkingRequested ook true is. */
    parkingAssigned: boolean;
    /** Voor welke periode de aanmelding geldt. De periode valt binnen de volgende waarden: HELE_DAG, HALVE_DAG */
    periode: Periode;
};
export type BedrijfView = {
    /** De naam van het bedrijf */
    naam: string;
    /** De URL van het logo van het bedrijf */
    logo: string;
    /** E-maildomein waarmee gebruikers aan dit bedrijf gekoppeld worden */
    domain: string;
    /** Naam van het gebouw waar dit bedrijf gehuisvest is */
    building: string;
};
export type CompanyWrite = {
    /** E-maildomein waarmee gebruikers aan dit bedrijf gekoppeld worden */
    domain: string;
    /** URL van het logo van het bedrijf */
    logo: string;
    /** Naam van het gebouw waar dit bedrijf gehuisvest is */
    building: string;
};
export type DeleteImpact = {
    /** Ondergrens (niet het exacte aantal!) van bekende gebruikers die op dit moment via het e-maildomein aan dit bedrijf gekoppeld zijn: minstens dit aantal, mogelijk meer. Alleen gebruikers met een opgeslagen voorkeur of APN-token zijn hierin te vinden (best-effort, zie research.md Decision 4) -- een gebruiker die de app alleen lezend heeft gebruikt telt hier niet in mee, ook al is die wel degelijk lid van dit bedrijf. */
    matchingUserCount: number;
};
export type DeploymentInfoResponse = {
    environment: string;
    image: string;
    revision: string;
    service: string;
};
export type Room = {
    /** The name of the room */
    name: string;
    /** The number of seats in the room */
    seats: number;
};
export type BuildingFeatures = {
    /** Geeft aan of het gebouw parkeerplekken heeft */
    hasParking: boolean;
    /** Geeft aan of het gebouw kamers heeft. Zonder kamers kan alleen NoRoom worden gebruikt */
    hasRooms: boolean;
};
export type BuildingView = {
    /** Naam van het gebouw */
    name: string;
    /** Aantal parkeerplekken van het gebouw. Bij 0 kunnen geen parkeerplekken worden aangevraagd */
    parkingSpots: number;
    /** Identifier van de parkeerslagboom, indien aanwezig */
    parkingGate: string | null;
    /** Kamers die bij het gebouw horen */
    rooms: Room[];
    /** Absolute URL van de gebouwafbeelding */
    picture: string;
    /** Geeft aan of dit het standaardgebouw is */
    default: boolean;
    /** Totaal aantal werkplekken in het gebouw, op basis van alle kamers */
    seats: number;
    /** Aantal werkplekken per kamer */
    seatsPerRoom: {
        [key: string]: number;
    };
    /** Feature-instellingen van het gebouw */
    features: BuildingFeatures;
};
export type BuildingUpdate = {
    /** Aantal beschikbare parkeerplekken */
    parkingSpots: number;
    /** Identifier van de parkeerslagboom, indien aanwezig */
    parkingGate?: string | null;
    /** Bestandsnaam van de gebouwafbeelding */
    picture: string;
    /** Feature-instellingen van het gebouw */
    features: BuildingFeatures;
};
export type RoomSize = {
    /** Nieuw aantal werkplekken in de kamer */
    size: number;
};
export type RoomNameUpdate = {
    /** Nieuwe naam van de kamer */
    newName: string;
};
export type KantoordagView = {
    /** Datum van de kantoordag */
    date: LocalDate;
    /** Gebouwnaam, afkomstig uit het gebouw-overzicht */
    building: string;
    /** Totale capaciteit van het gebouw */
    capacity: number;
    /** Aantal nog beschikbare werkplekken */
    seatsAvailable: number;
    /** Totaal aantal aanmeldingen */
    reservations: number;
    /** Aantal aanmeldingen voor een specifieke werkplek */
    spotReservations: number;
    /** Aantal gebruikers met toegewezen werkplek */
    assignedSpots: number;
    /** Aantal gebruikers op de wachtlijst */
    waitlistSize: number;
    /** Bezettingspercentage van de capaciteit (0-100) */
    capacityPercentage: number;
};
export type UserKantoordagView = {
    /** Datum van de kantoordag */
    date: LocalDate;
    /** Gebouwnaam waarop deze gebruikersweergave betrekking heeft */
    building: string;
    /** Unieke gebruikers-id */
    userId: string;
    /** Weergavenaam van de gebruiker */
    userName: string;
    /** URL van de profielfoto, indien beschikbaar */
    picture?: string | null;
    /** Geeft aan of de gebruiker een parkeerplek heeft aangevraagd */
    requestedParkingspot: boolean;
    /** Aangemelde periode op de dag */
    periode: Periode;
    /** Geeft aan of de gebruiker een werkplek toegewezen heeft */
    hasWorkspot: boolean;
    /** Geeft aan of de gebruiker een parkeerplek toegewezen heeft */
    assignedParkingspot: boolean;
};
export type CompanyKantoordagView = {
    /** Datum van de kantoordag */
    date: LocalDate;
    /** Gebouwnaam waarop deze bedrijfsweergave betrekking heeft */
    building: string;
    /** Naam van het bedrijf */
    companyName: string;
    /** URL van het bedrijfslogo */
    companyLogo: string;
    /** Totaal aantal aanmeldingen van dit bedrijf */
    totalReservations: number;
    /** Gebruikers van dit bedrijf met hun status */
    users: UserKantoordagView[];
};
export type KantoordagViewResponse = {
    /** Overzicht van de totale bezetting voor de gekozen dag en locatie */
    summary: KantoordagView;
    /** Bedrijfsweergaven, gegroepeerd op bedrijfsnaam */
    companies: {
        [key: string]: CompanyKantoordagView;
    };
};
export type Id = {
    /** Unieke numerieke identifier van het bericht */
    id: number;
};
export type MessageOfTheDay = {
    /** Unieke identifier van het bericht */
    id: Id;
    /** Titel van het bericht */
    title: string;
    /** Inhoud van het bericht */
    message: string;
};
export type ParkingDayReport = {
    date: LocalDate;
    illegalParkingsBy: string[];
};
export type ParkingReport = {
    days: ParkingDayReport[];
};
export type IllegalParkingReport = {
    /** Overzicht per gebouwnaam met de gevonden meldingen */
    report: {
        [key: string]: ParkingReport;
    };
};
export type LocalDateTime = string;
export type ReservationView = {
    /** Datum van de reservering */
    date: LocalDate;
    /** Gebouwnaam waarvoor de parkeerreservering geldt */
    building: string;
    /** Unieke gebruikers-id */
    userId: string;
    /** Weergavenaam van de gebruiker */
    userName: string;
    /** Tijdstip waarop de reservering is aangemaakt */
    reservationDate: LocalDateTime;
    /** Geeft aan of een parkeerplek daadwerkelijk is toegewezen */
    reserved: boolean;
    /** Aangemelde periode waarvoor de reservering geldt */
    periode: Periode;
};
export type FirebaseTokenResponse = {
    customToken: string;
};
export type ApnToken = {
    /** Apple Push Notification token van de gebruiker */
    apn: string;
};
export type OffsetDateTime = string;
export type ExternalUserSummary = {
    id: string;
    displayName: string;
    email: string;
    invitationState: string;
    invitationStateChangedAt: OffsetDateTime | null;
    revoked: boolean;
};
export type ExternalUser = {
    /** De echte, bereikbare e-mailadres van de externe gebruiker waarnaar de uitnodiging wordt verstuurd */
    userId: string;
    /** Weergavenaam van de externe gebruiker */
    userName: string;
};
export type SignupPrefs = {
    building?: string | null;
    room?: string | null;
    parkingRequested?: boolean | null;
    periode?: Periode | null;
};
export type UserPreferences = {
    userId: string;
    notifications: {
        [key: string]: boolean;
    };
    signup: SignupPrefs;
    signupPreference?: SignupPrefs;
};
export type NotificationPreferred = {
    /** Geeft aan of de notificatie is ingeschakeld */
    preferred: boolean;
};
export type MigratedItem = {
    id: string;
    message: string;
};
export type KantoordagViewMigratorParams = {
    buildingName?: string;
    fromDate?: string | null;
};
export type MyReservationViewMigratorParams = {
    includeHistory?: boolean;
    fromDate?: string | null;
};
export type MigratorParams = KantoordagViewMigratorParams | MyReservationViewMigratorParams;
export type RoomUser = {
    /** Unieke gebruikers-id */
    userId: string;
    /** Weergavenaam van de gebruiker */
    userName: string;
    /** URL van de profielfoto, indien beschikbaar */
    picture?: string | null;
    /** Naam van het bedrijf van de gebruiker */
    company: string;
    /** URL van het bedrijfslogo */
    companyLogo: string;
    /** Kamer waarin de gebruiker is ingedeeld */
    room: string;
};
export type RoomWithUsers = {
    /** Naam van de kamer */
    room: string;
    /** Totaal aantal werkplekken in de kamer */
    totalSeats: number;
    /** Aantal beschikbare werkplekken in de kamer */
    seatsAvailable: number;
    /** Aantal toegewezen werkplekken in de kamer */
    assigned: number;
    /** Bezettingspercentage van de kamer (0-100) */
    capacityPercentage: number;
    /** Gebruikers die in deze kamer zijn ingedeeld */
    users: RoomUser[];
    /** Geeft aan of de kamer is geblokkeerd */
    blocked: boolean;
};
export type WorkplaceView = {
    /** Aantal direct beschikbare werkplekken */
    seatsAvailable: number;
    /** Aantal gebruikers op de wachtlijst */
    onWaitList: number;
    /** Totale capaciteit van het gebouw */
    totalSeats: number;
    /** Bezettingspercentage van de totale capaciteit (0-100) */
    capacityPercentage: number;
    /** Overzicht van kamers met bezetting en toegewezen gebruikers */
    rooms: RoomWithUsers[];
    /** Gebruikers die op de wachtlijst staan */
    waitlist: RoomUser[];
};
export enum Periode {
    HeleDag = "HELE_DAG",
    DagDeel = "DAG_DEEL",
}
export enum Notification {
    SpotReserved = "SPOT_RESERVED",
    SpotWaitlisted = "SPOT_WAITLISTED",
    ReservationRevoked = "RESERVATION_REVOKED",
    ParkingAssigned = "PARKING_ASSIGNED",
    ParkingRevoked = "PARKING_REVOKED",
}
export enum Migrators {
    KantoordagViewGenerator = "KANTOORDAG_VIEW_GENERATOR",
    MyReservationViewGenerator = "MY_RESERVATION_VIEW_GENERATOR",
}
export const {
    useBatchAanmeldenMutation,
    useLastYearUsersQuery,
    useMonthlyReportGroupedByWeekQuery,
    useMonthlyReportQuery,
    useGetUpcomingAanmeldingenForUserQuery,
    useGetAanmeldingenOnDateQuery,
    useAfmeldenMutation,
    useGetAanmeldingenOnDateForUserQuery,
    useAanmeldenMutation,
    useGetBedrijvenQuery,
    useGetBedrijfForUserQuery,
    useUpdateCompanyMutation,
    useDeleteCompanyMutation,
    useCreateCompanyMutation,
    useGetBedrijfByNameQuery,
    useGetCompanyDeleteImpactQuery,
    useGetApiDeploymentInfoQuery,
    useGetRedeliveryProbeQuery,
    useCreateRedeliveryProbeMutation,
    useGetAllBuildingsQuery,
    useRegenerateDefaultsMutation,
    useMigrateSyntheticRoomsMutation,
    useGetBuildingPicturesQuery,
    useUpdateBuildingMutation,
    useDeleteBuildingMutation,
    useCreateBuildingMutation,
    useGetBuildingQuery,
    useSetDefaultBuildingMutation,
    useUpsertRoomMutation,
    useRenameRoomMutation,
    useDeleteRoomMutation,
    useUnblockRoomMutation,
    useBlockRoomMutation,
    useGetAllKantoordagenQuery,
    useGetKantoordagOnDateQuery,
    useGetMessagesOfTheDayQuery,
    useSendIllegalParkingReportMutation,
    useGetIllegalParkingReportQuery,
    useGetParkingSpotsQuery,
    useAssignParkingSpotsMutation,
    useGetIllegalParkingReportForBuildingQuery,
    useExchangeFirebaseTokenMutation,
    useStoreApnTokenMutation,
    useListExternalUsersQuery,
    useCreateExternalUserMutation,
    useRevokeExternalUserMutation,
    useReinstateExternalUserMutation,
    useResendExternalUserInvitationMutation,
    useGetUserPreferencesQuery,
    useStoreNotificationPreferenceMutation,
    useStoreSignupPreferenceMutation,
    useClearPhotoCacheMutation,
    useGetUserProfileImageQuery,
    useGenerateKantoordagViewMutation,
    useMigrateViewsMutation,
    useRegenerateMyReservationsViewsMutation,
    useGetWorkplaceOnDateForBuildingQuery,
    useGetWorkplaceOnDateQuery,
} = injectedRtkApi;
